// Libs
import React, { Component } from "react";
import { X, ChevronRight } from "react-feather";
import _ from "lodash";
import OutsideClickHandler from "react-outside-click-handler";
// CSS
import "./styles.scss";

class SideBar extends Component {
  state = { timer: null };

  render() {
    const { visible, title, button, children, handleOpen, handleClose } =
      this.props;
    return (
      <OutsideClickHandler onOutsideClick={() => handleClose()}>
        <div
          id="side-bar"
          className={visible ? "side-bar side-bar--visible" : "side-bar"}
          onClick={!visible ? handleOpen : undefined}
        >
          <div className="side-bar__header">
            <p className="side-bar__title">{title}</p>
            <div id="side-bar__close" className="side-bar__close-icon">
              <X size={30} onClick={() => handleClose()} />
            </div>
          </div>
          {children}
          <div id="side-bar__button" className="side-bar__button">
            <ChevronRight size={30} />
            <span>{button}</span>
          </div>
        </div>
      </OutsideClickHandler>
    );
  }
}

export default SideBar;
